import { parseSurfaceGeometry } from '../../shared/surface-geometry';
import { parsePaintedWallSectionSnapshot } from '../../shared/painted-wall-section-state';
import { type JanusCtx, type Row, handBack, scalar, upper } from '../ability/context';
import { emptySpawnPlan, mergeSpawnPlans } from '../spawn/row-plan';
import { encounterField } from '../../shared/array-types';
import { readInventoryField } from '../compile/inventory-raw-readers';

/** Anchor removal owns its exact inventory bindings, on both connection end and calendar expiry. */
export function retirePaintedWallSections(ctx: JanusCtx, status: Row): void {
  if (Number(scalar(ctx.read.value(status, 'status_aoe_source')) ?? 0) !== 1) return;
  const raw = scalar(ctx.read.value(status, 'status_aoe_geometry'));
  if (raw == null || raw === '' || parseSurfaceGeometry(raw)) return;
  const snapshot = parsePaintedWallSectionSnapshot(raw);
  if (!snapshot) handBack('painted-wall-sections:removal-document-not-held');
  if (!snapshot.sections?.entries.length) return;
  const target = upper(scalar(ctx.read.value(status, 'status_target_id')));
  if (target !== upper(encounterField(ctx.encounter, 'encounter_id'))) handBack('painted-wall-sections:removal-encounter-mismatch');
  const inventory = Array.isArray(ctx.encounter.encounter_inventories_arr) ? ctx.encounter.encounter_inventories_arr as Row[] : [];
  const rows = new Map(inventory.map(row => [upper(readInventoryField(row, 'inventory_id')), row]));
  const plan = emptySpawnPlan();
  for (const entry of snapshot.sections.entries) {
    const row = rows.get(upper(entry.inventoryId));
    if (row && Number(readInventoryField(row, 'inventory_deleted') ?? 0)) continue;
    // Deleted/breached sections may already be absent from the lean roster. The anchor still owns their identities.
    plan.writes.push({ table: 'inventory', op: 'update', row: { inventory_id: entry.inventoryId, inventory_deleted: 1, item_qty: 0 },
      ...(row ? { before: { inventory_deleted: Number(readInventoryField(row, 'inventory_deleted') ?? 0),
        item_qty: Number(readInventoryField(row, 'item_qty') ?? 1) } } : {}) });
  }
  ctx.spawnRows = mergeSpawnPlans(ctx.spawnRows, plan);
}
